module.exports = __webpack_public_path__ + "img/bg.aa99f88d.jpeg";